import React, { useState, useEffect } from 'react';
import toast, { Toaster } from "react-hot-toast";
import axios from 'axios';
import Swal from "sweetalert2";





// ─────────────────────────────────────────────────────────────────────────────

const SmsGroup = () => {

    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');
    const userDetails = JSON.parse(localStorage.getItem('user_details'));

    const [modalType, setModalType] = useState(0); // 0-add, 1-edit

    const [allBranchesList, setAllBranchesList] = useState([]);
    const [branchDropDValue, setBranchDropDValue] = useState(0);
    const [selectedBranchId, setSelectedBranchId] = useState(null);

    const [allSmsGroupList, setAllSmsGroupList] = useState([]);
    const [selectedSmsGroup, setSelectedSmsGroup] = useState({});
    const [assignedPhoneNumbers, setAssignedPhoneNumbers] = useState([]);
    const [assignedEmails, setAssignedEmails] = useState([]);

    const [showAddGroupModal, setShowAddGroupModal] = useState(false);
    const [newGroupName, setNewGroupName] = useState('');

    const [showEditGroupModal, setShowEditGroupModal] = useState(false);
    const [editGroupName, setEditGroupName] = useState('');

    const [showAddNumbersModal, setShowAddNumbersModal] = useState(false);
    const [phoneInputs, setPhoneInputs] = useState(['']);

    const [showAddEmailsModal, setShowAddEmailsModal] = useState(false);
    const [emailInputs, setEmailInputs] = useState(['']);

    const [showAssignGroupsModal, setShowAssignGroupsModal] = useState(false);
    const [assignMode, setAssignMode] = useState('numbers'); // 'numbers' | 'emails'
    const [assignSearch, setAssignSearch] = useState('');
    const [selectedAssignNumber, setSelectedAssignNumber] = useState(null);
    const [allMobileNumbers, setAllMobileNumbers] = useState([]);
    const [numberGroupsList, setNumberGroupsList] = useState([]);
    const [editingNumberId, setEditingNumberId] = useState(null);
    const [editingNumberValue, setEditingNumberValue] = useState('');
    const [allEmails, setAllEmails] = useState([]);
    const [emailSearch, setEmailSearch] = useState('');
    const [selectedAssignEmail, setSelectedAssignEmail] = useState(null);
    const [editingEmailId, setEditingEmailId] = useState(null);
    const [editingEmailValue, setEditingEmailValue] = useState('');

    // Load branches on mount
    useEffect(() => {
        axios({
            method: 'GET',
            url: `${baseUrl}/branch/get-branches/customer/${userDetails.cid}`,
            headers: { Authorization: localStorage.getItem('TS_GEN_TOKEN') }
        }).then((res) => {
            const data = res.data.data;
            setAllBranchesList(data);
            if (data.length > 0) {
                setSelectedBranchId(data[0].id);
            }
        }).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
        });
    }, []);

    // Load groups when branch changes
    useEffect(() => {
        if (selectedBranchId !== null) {
            setSelectedSmsGroup({});
            setAssignedPhoneNumbers([]);
            setAssignedEmails([]);
            getAllSmsGroups();
        }
    }, [selectedBranchId]);

    const getAllSmsGroups = () => {
        axios({
            method: 'GET',
            url: `${baseUrl}/mobile-group/branch/${selectedBranchId}/get-all`,
            headers: { Authorization: token }
        }).then((res) => {
            const data = res.data.data;
            setAllSmsGroupList(data);
            if (data.length > 0) {
                setSelectedSmsGroup(data[0]);
            }
        }).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
        });
    };

    // Load phone numbers and emails when group is selected
    useEffect(() => {
        if (Object.keys(selectedSmsGroup).length > 0) {
            getNumbersByGroup();
            getEmailsByGroup();
        }
    }, [selectedSmsGroup]);

    const getNumbersByGroup = () => {
        axios({
            method: 'GET',
            url: `${baseUrl}/mobile-group/${selectedSmsGroup.id}/get-numbers`,
            headers: { Authorization: token }
        }).then((res) => {
            const numbers = res.data.data.map((num, i) => ({ id: i, number: num }));
            setAssignedPhoneNumbers(numbers);
        }).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
        });
    };

    // `/mobile-group/branch/{id}/get-all-emails` is the only endpoint that
    // returns real email records (with their DB `id`). Fetch + cache it so
    // we can resolve the real id for emails coming back from
    // `/mobile-group/{id}/get-emails`, which only returns bare address strings.
    const fetchAllEmailsForBranch = () => {
        return axios({
            method: 'GET',
            url: `${baseUrl}/mobile-group/branch/${selectedBranchId}/get-all-emails`,
            headers: { Authorization: token }
        }).then((res) => {
            const data = res.data.data || [];
            setAllEmails(data);
            return data;
        });
    };

    const getEmailsByGroup = () => {
        axios({
            method: 'GET',
            url: `${baseUrl}/mobile-group/${selectedSmsGroup.id}/get-emails`,
            headers: { Authorization: token }
        }).then((res) => {
            const rawEmails = res.data.data || [];

            const mapToRealIds = (fullList) => {
                setAssignedEmails(
                    rawEmails.map((email) => {
                        const match = fullList.find((m) => m.email === email);
                        return { id: match ? match.id : null, email };
                    })
                );
            };

            if (allEmails.length > 0) {
                mapToRealIds(allEmails);
            } else {
                fetchAllEmailsForBranch()
                    .then((fullList) => mapToRealIds(fullList))
                    .catch((error) => {
                        console.log(error);
                        // Still show the emails even if we couldn't resolve ids.
                        setAssignedEmails(rawEmails.map((email) => ({ id: null, email })));
                    });
            }
        }).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
        });
    };

    const handleSelectBranch = (index) => {
        setBranchDropDValue(index);
        setSelectedBranchId(allBranchesList[index].id);
    };

    const deleteSMSGroup = () => {
        Swal.fire({
            position: 'center',
            text: 'Do you want to delete this SMS Group?',
            showConfirmButton: true,
            confirmButtonText: 'Yes',
            showCancelButton: true,
            cancelButtonText: 'No',
            width: '400px',
        }).then((result) => {
            if (result.value === true) {
                axios({
                    method: 'POST',
                    url: `${baseUrl}/mobile-group/${selectedSmsGroup.id}/delete`,
                    headers: { Authorization: token }
                }).then((res) => {
                    getAllSmsGroups();
                    setSelectedSmsGroup({});
                    setAssignedPhoneNumbers([]);
                    toast.remove();
                    toast.success('Deleted Successfully', { position: 'bottom-center' });
                }).catch((error) => {
                    console.log(error);
                    toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                });
            }
        });
    };

    return (
        <>
            <div><Toaster /></div>
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-4 col-sm-12">
                            <h1>SMS and Email Groups</h1>
                        </div>
                        <div className="col-md-8 col-sm-12 text-right hidden-xs">
                            <div className="row clearfix ml-5">
                                <div className="col-md-6 col-sm-12 text-right">
                                    <select
                                        className="custom-select modal-select-field mr-2 select-branch-dropdown"
                                        value={branchDropDValue}
                                        onChange={(e) => handleSelectBranch(parseInt(e.target.value))}
                                    >
                                        {allBranchesList.map((item, index) => (
                                            <option value={index} key={index}>{item.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div
                                    className="btn btn-sm btn-primary mr-1"
                                    title="Add New SMS Group"
                                    onClick={() => {
                                        setNewGroupName('');
                                        setShowAddGroupModal(true);
                                    }}
                                >Add New</div>
                                <div
                                    className="btn btn-sm btn-primary mr-1"
                                    title="Add Mobile Numbers"
                                    onClick={() => {
                                        setPhoneInputs(['']);
                                        setShowAddNumbersModal(true);
                                    }}
                                >Add Mobile Numbers</div>
                                <div
                                    className="btn btn-sm btn-primary mr-1"
                                    title="Add Emails"
                                    onClick={() => {
                                        setEmailInputs(['']);
                                        setShowAddEmailsModal(true);
                                    }}
                                >Add Emails</div>
                                <div
                                    className="btn btn-sm btn-primary mr-1"
                                    title="Assign Groups"
                                    onClick={() => {
                                        setAssignSearch('');
                                        setEmailSearch('');
                                        setAssignMode('numbers');
                                        setSelectedAssignNumber(null);
                                        setSelectedAssignEmail(null);
                                        setAllMobileNumbers([]);
                                        setAllEmails([]);
                                        setNumberGroupsList([]);
                                        setShowAssignGroupsModal(true);
                                        axios({
                                            method: 'GET',
                                            url: `${baseUrl}/mobile-group/branch/${selectedBranchId}/get-all-mobile-numbers`,
                                            headers: { Authorization: token }
                                        }).then((res) => {
                                            setAllMobileNumbers(res.data.data);
                                        }).catch((error) => {
                                            console.log(error);
                                            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                        });
                                    }}
                                >Assign Groups</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row clearfix">

                    {/* ── Left: Groups List ── */}
                    <div className="col-lg-3 col-md-3">
                        <ul className="list-group mb-4 right-custom-nav">
                            {allSmsGroupList.length > 0 ? (
                                allSmsGroupList.map((group, i) => (
                                    <li
                                        key={i}
                                        className={`list-group-item d-flex justify-content-between align-items-center country-select${group.id === selectedSmsGroup.id ? ' active' : ''}`}
                                        onClick={() => setSelectedSmsGroup(group)}
                                    >
                                        {group.name}
                                    </li>
                                ))
                            ) : (
                                <li className="list-group-item d-flex justify-content-between align-items-center">No Data</li>
                            )}
                        </ul>
                    </div>

                    {/* ── Right: Group Detail ── */}
                    <div className="col-lg-9 col-md-9">
                        <div className="card">
                            {Object.keys(selectedSmsGroup).length > 0 ? (
                                <div className="body top_counter">

                                    {/* Header with edit/delete */}
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="vertically-align-center-flex m-b-15">
                                                <div>
                                                    Group :&nbsp;
                                                    <span className="badge badge-warning sms-template-badge">
                                                        {selectedSmsGroup.name}
                                                    </span>
                                                </div>
                                                <div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-default"
                                                        title="Edit"
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        onClick={() => {
                                                            setEditGroupName(selectedSmsGroup.name);
                                                            setShowEditGroupModal(true);
                                                        }}
                                                    >
                                                        <i className="fa fa-pencil-square-o"> </i>
                                                    </button>
                                                    &nbsp;
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-default"
                                                        title="Delete"
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        onClick={deleteSMSGroup}
                                                    >
                                                        <i className="icon-trash"> </i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Assigned Numbers & Emails */}
                                    <div className="row">
                                        {/* Left: Phone Numbers */}
                                        <div className="col-6" style={{ borderRight: '1px solid #e9ecef' }}>
                                            <p className="advance-view-title mb-2">Assigned Phone Numbers</p>
                                            <ul className="list-group">
                                                {assignedPhoneNumbers.length > 0 ? (
                                                    assignedPhoneNumbers.map((item, i) => (
                                                        <li key={i} className="list-group-item kiosk-template-label d-flex justify-content-between align-items-center">
                                                            <span style={{ fontSize: '16px' }}>{item.number}</span>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-default"
                                                                title="Remove"
                                                                onClick={() => {
                                                                    Swal.fire({
                                                                        position: 'center',
                                                                        text: 'Remove this number from the group?',
                                                                        showConfirmButton: true,
                                                                        confirmButtonText: 'Yes',
                                                                        showCancelButton: true,
                                                                        cancelButtonText: 'No',
                                                                        width: '400px',
                                                                    }).then((result) => {
                                                                        if (result.value === true) {
                                                                            axios({
                                                                                method: 'POST',
                                                                                url: `${baseUrl}/mobile-group/assign-to-number`,
                                                                                headers: { Authorization: token },
                                                                                data: {
                                                                                    number: item.id,
                                                                                    groupId: selectedSmsGroup.id
                                                                                }
                                                                            }).then(() => {
                                                                                setAssignedPhoneNumbers(assignedPhoneNumbers.filter(p => p.id !== item.id));
                                                                                toast.success('Number removed from group', { position: 'bottom-center' });
                                                                            }).catch((error) => {
                                                                                console.log(error);
                                                                                toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                                                            });
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i className="icon-trash"></i>
                                                            </button>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li className="list-group-item">No assigned phone numbers.</li>
                                                )}
                                            </ul>
                                        </div>

                                        {/* Right: Emails */}
                                        <div className="col-6">
                                            <p className="advance-view-title mb-2">Assigned Emails</p>
                                            <ul className="list-group">
                                                {assignedEmails.length > 0 ? (
                                                    assignedEmails.map((item, i) => (
                                                        <li key={i} className="list-group-item kiosk-template-label d-flex justify-content-between align-items-center">
                                                            <span style={{ fontSize: '16px' }}>{item.email}</span>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-default"
                                                                title="Remove"
                                                                onClick={() => {
                                                                    if (item.id === null || item.id === undefined) {
                                                                        toast.error('Could not resolve this email\'s id, please refresh and try again', { position: 'bottom-center' });
                                                                        return;
                                                                    }
                                                                    Swal.fire({
                                                                        position: 'center',
                                                                        text: 'Remove this email from the group?',
                                                                        showConfirmButton: true,
                                                                        confirmButtonText: 'Yes',
                                                                        showCancelButton: true,
                                                                        cancelButtonText: 'No',
                                                                        width: '400px',
                                                                    }).then((result) => {
                                                                        if (result.value === true) {
                                                                            axios({
                                                                                method: 'POST',
                                                                                url: `${baseUrl}/mobile-group/assign-to-email`,
                                                                                headers: { Authorization: token },
                                                                                data: {
                                                                                    emailId: item.id,
                                                                                    groupId: selectedSmsGroup.id
                                                                                }
                                                                            }).then(() => {
                                                                                setAssignedEmails(assignedEmails.filter((_, idx) => idx !== i));
                                                                                toast.success('Email removed from group', { position: 'bottom-center' });
                                                                            }).catch((error) => {
                                                                                console.log(error);
                                                                                toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                                                            });
                                                                        }
                                                                    });
                                                                }}
                                                            >
                                                                <i className="icon-trash"></i>
                                                            </button>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li className="list-group-item">No assigned emails.</li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            ) : (
                                <p style={{ padding: '15px' }}>Select a group</p>
                            )}
                        </div>
                    </div>

                </div>
            </div>
            {/* ── Add Group Modal ── */}
            {showAddGroupModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">Add New Group</h5>
                                <button type="button" className="close" onClick={() => setShowAddGroupModal(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Group Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter group name"
                                        value={newGroupName}
                                        onChange={(e) => setNewGroupName(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowAddGroupModal(false)}>Cancel</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        if (newGroupName.trim() === '') {
                                            toast.error('Group name is required', { position: 'bottom-center' });
                                            return;
                                        }
                                        axios({
                                            method: 'POST',
                                            url: `${baseUrl}/mobile-group/add`,
                                            headers: { Authorization: token },
                                            data: {
                                                name: newGroupName.trim(),
                                                branch: { id: selectedBranchId }
                                            }
                                        }).then((res) => {
                                            getAllSmsGroups();
                                            setShowAddGroupModal(false);
                                            toast.success('Group added', { position: 'bottom-center' });
                                        }).catch((error) => {
                                            console.log(error);
                                            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                        });
                                    }}
                                >Add</button>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {/* ── Edit Group Modal ── */}
            {showEditGroupModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">Edit Group</h5>
                                <button type="button" className="close" onClick={() => setShowEditGroupModal(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Group Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter group name"
                                        value={editGroupName}
                                        onChange={(e) => setEditGroupName(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowEditGroupModal(false)}>Cancel</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        if (editGroupName.trim() === '') {
                                            toast.error('Group name is required', { position: 'bottom-center' });
                                            return;
                                        }
                                        axios({
                                            method: 'POST',
                                            url: `${baseUrl}/mobile-group/update`,
                                            headers: { Authorization: token },
                                            data: {
                                                id: selectedSmsGroup.id,
                                                name: editGroupName.trim(),
                                                branch: { id: selectedBranchId },
                                                deleted: false
                                            }
                                        }).then((res) => {
                                            getAllSmsGroups();
                                            setSelectedSmsGroup({ ...selectedSmsGroup, name: editGroupName.trim() });
                                            setShowEditGroupModal(false);
                                            toast.success('Group updated', { position: 'bottom-center' });
                                        }).catch((error) => {
                                            console.log(error);
                                            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                        });
                                    }}
                                >Update</button>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {/* ── Assign Groups Modal ── */}
            {showAssignGroupsModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">Assign Groups</h5>
                                <button type="button" className="close" onClick={() => setShowAssignGroupsModal(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" style={{ minHeight: '400px' }}>
                                <div className="row" style={{ height: '100%' }}>

                                    {/* Left: toggle + search */}
                                    <div className="col-5" style={{ borderRight: '1px solid #e9ecef' }}>
                                        <div className="btn-group w-100 mb-3" role="group">
                                            <button
                                                type="button"
                                                className={`btn btn-sm ${assignMode === 'numbers' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={() => {
                                                    if (assignMode !== 'numbers') {
                                                        setAssignMode('numbers');
                                                        setAssignSearch('');
                                                        setSelectedAssignEmail(null);
                                                        setNumberGroupsList([]);
                                                    }
                                                }}
                                            >Mobile Numbers</button>
                                            <button
                                                type="button"
                                                className={`btn btn-sm ${assignMode === 'emails' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                onClick={() => {
                                                    if (assignMode !== 'emails') {
                                                        setAssignMode('emails');
                                                        setEmailSearch('');
                                                        setSelectedAssignNumber(null);
                                                        setNumberGroupsList([]);
                                                        if (allEmails.length === 0) {
                                                            fetchAllEmailsForBranch().catch((error) => {
                                                                console.log(error);
                                                                toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                                            });
                                                        }
                                                    }
                                                }}
                                            >Emails</button>
                                        </div>

                                        {assignMode === 'numbers' ? (
                                            <>
                                                <div className="input-group mb-3">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search number..."
                                                        value={assignSearch}
                                                        onChange={(e) => setAssignSearch(e.target.value)}
                                                    />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text"><i className="fa fa-search"></i></span>
                                                    </div>
                                                </div>
                                                <ul className="list-group">
                                                    {allMobileNumbers
                                                        .filter(n => n.number.includes(assignSearch.trim()))
                                                        .map((n, i) => (
                                                            <li
                                                                key={i}
                                                                className={`list-group-item d-flex justify-content-between align-items-center country-select${selectedAssignNumber && selectedAssignNumber.id === n.id ? ' active' : ''}`}
                                                                onClick={() => {
                                                                    if (editingNumberId !== n.id) {
                                                                        setSelectedAssignNumber(n);
                                                                        setNumberGroupsList([]);
                                                                        axios({
                                                                            method: 'GET',
                                                                            url: `${baseUrl}/mobile-group/get-assigned-by-number/${n.number}`,
                                                                            headers: { Authorization: token }
                                                                        }).then((res) => {
                                                                            setNumberGroupsList(res.data.data);
                                                                        }).catch((error) => {
                                                                            console.log(error);
                                                                            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                                                        });
                                                                    }
                                                                }}
                                                            >
                                                                {editingNumberId === n.id ? (
                                                                    <input
                                                                        type="text"
                                                                        className="form-control form-control-sm mr-2"
                                                                        value={editingNumberValue}
                                                                        autoFocus
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        onChange={(e) => setEditingNumberValue(e.target.value)}
                                                                    />
                                                                ) : (
                                                                    <span>{n.number}</span>
                                                                )}
                                                                <div className="d-flex" onClick={(e) => e.stopPropagation()}>
                                                                    {editingNumberId === n.id ? (
                                                                        <>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-success mr-1"
                                                                                title="Save"
                                                                                onClick={() => {
                                                                                    if (editingNumberValue.trim() === '') {
                                                                                        toast.error('Number cannot be empty', { position: 'bottom-center' });
                                                                                        return;
                                                                                    }
                                                                                    axios({
                                                                                        method: 'POST',
                                                                                        url: `${baseUrl}/mobile-group/update-number`,
                                                                                        headers: { Authorization: token },
                                                                                        data: {
                                                                                            id: n.id,
                                                                                            number: editingNumberValue.trim(),
                                                                                            branch: { id: selectedBranchId },
                                                                                            deleted: false
                                                                                        }
                                                                                    }).then(() => {
                                                                                        setAllMobileNumbers(allMobileNumbers.map(m =>
                                                                                            m.id === n.id ? { ...m, number: editingNumberValue.trim() } : m
                                                                                        ));
                                                                                        if (selectedAssignNumber?.id === n.id) {
                                                                                            setSelectedAssignNumber({ ...n, number: editingNumberValue.trim() });
                                                                                        }
                                                                                        setEditingNumberId(null);
                                                                                        toast.success('Number updated', { position: 'bottom-center' });
                                                                                    }).catch((error) => {
                                                                                        console.log(error);
                                                                                        toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                                                                    });
                                                                                }}
                                                                            ><i className="fa fa-check"></i></button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-secondary"
                                                                                title="Cancel"
                                                                                onClick={() => setEditingNumberId(null)}
                                                                            ><i className="fa fa-times"></i></button>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-primary mr-1"
                                                                                title="Edit"
                                                                                onClick={() => {
                                                                                    setEditingNumberId(n.id);
                                                                                    setEditingNumberValue(n.number);
                                                                                }}
                                                                            ><i className="fa fa-pencil-square-o"></i></button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-danger"
                                                                                title="Delete"
                                                                                onClick={() => {
                                                                                    Swal.fire({
                                                                                        position: 'center',
                                                                                        text: 'Do you want to delete this number?',
                                                                                        showConfirmButton: true,
                                                                                        confirmButtonText: 'Yes',
                                                                                        showCancelButton: true,
                                                                                        cancelButtonText: 'No',
                                                                                        width: '400px',
                                                                                    }).then((result) => {
                                                                                        if (result.value === true) {
                                                                                            axios({
                                                                                                method: 'POST',
                                                                                                url: `${baseUrl}/mobile-group/number/${n.id}/delete`,
                                                                                                headers: { Authorization: token }
                                                                                            }).then(() => {
                                                                                                setAllMobileNumbers(allMobileNumbers.filter(m => m.id !== n.id));
                                                                                                if (selectedAssignNumber?.id === n.id) setSelectedAssignNumber(null);
                                                                                                toast.success('Number deleted', { position: 'bottom-center' });
                                                                                            }).catch((error) => {
                                                                                                console.log(error);
                                                                                                toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                                                                            });
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            ><i className="icon-trash"></i></button>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </li>
                                                        ))
                                                    }
                                                    {allMobileNumbers.filter(n => n.number.includes(assignSearch.trim())).length === 0 && (
                                                        <li className="list-group-item">No results</li>
                                                    )}
                                                </ul>
                                            </>
                                        ) : (
                                            <>
                                                <div className="input-group mb-3">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search email..."
                                                        value={emailSearch}
                                                        onChange={(e) => setEmailSearch(e.target.value)}
                                                    />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text"><i className="fa fa-search"></i></span>
                                                    </div>
                                                </div>
                                                <ul className="list-group">
                                                    {allEmails
                                                        .filter(e => e.email.toLowerCase().includes(emailSearch.trim().toLowerCase()))
                                                        .map((e, i) => (
                                                            <li
                                                                key={i}
                                                                className={`list-group-item d-flex justify-content-between align-items-center country-select${selectedAssignEmail && selectedAssignEmail.id === e.id ? ' active' : ''}`}
                                                                onClick={() => {
                                                                    if (editingEmailId !== e.id) {
                                                                        setSelectedAssignEmail(e);
                                                                        setNumberGroupsList([]);
                                                                        axios({
                                                                            method: 'POST',
                                                                            url: `${baseUrl}/mobile-group/get-assigned-by-email`,
                                                                            headers: { Authorization: token },
                                                                            data: { email: e.email }
                                                                        }).then((res) => {
                                                                            setNumberGroupsList(res.data.data);
                                                                        }).catch((error) => {
                                                                            console.log(error);
                                                                            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                                                        });
                                                                    }
                                                                }}
                                                            >
                                                                {editingEmailId === e.id ? (
                                                                    <input
                                                                        type="email"
                                                                        className="form-control form-control-sm mr-2"
                                                                        value={editingEmailValue}
                                                                        autoFocus
                                                                        onClick={(ev) => ev.stopPropagation()}
                                                                        onChange={(ev) => setEditingEmailValue(ev.target.value)}
                                                                    />
                                                                ) : (
                                                                    <span>{e.email}</span>
                                                                )}
                                                                <div className="d-flex" onClick={(ev) => ev.stopPropagation()}>
                                                                    {editingEmailId === e.id ? (
                                                                        <>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-success mr-1"
                                                                                title="Save"
                                                                                onClick={() => {
                                                                                    if (editingEmailValue.trim() === '') {
                                                                                        toast.error('Email cannot be empty', { position: 'bottom-center' });
                                                                                        return;
                                                                                    }
                                                                                    axios({
                                                                                        method: 'POST',
                                                                                        url: `${baseUrl}/mobile-group/update-email`,
                                                                                        headers: { Authorization: token },
                                                                                        data: {
                                                                                            id: e.id,
                                                                                            email: editingEmailValue.trim(),
                                                                                            branch: { id: selectedBranchId },
                                                                                            deleted: false
                                                                                        }
                                                                                    }).then(() => {
                                                                                        setAllEmails(allEmails.map(m =>
                                                                                            m.id === e.id ? { ...m, email: editingEmailValue.trim() } : m
                                                                                        ));
                                                                                        if (selectedAssignEmail?.id === e.id) {
                                                                                            setSelectedAssignEmail({ ...e, email: editingEmailValue.trim() });
                                                                                        }
                                                                                        setEditingEmailId(null);
                                                                                        toast.success('Email updated', { position: 'bottom-center' });
                                                                                    }).catch((error) => {
                                                                                        console.log(error);
                                                                                        toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                                                                    });
                                                                                }}
                                                                            ><i className="fa fa-check"></i></button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-secondary"
                                                                                title="Cancel"
                                                                                onClick={() => setEditingEmailId(null)}
                                                                            ><i className="fa fa-times"></i></button>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-primary mr-1"
                                                                                title="Edit"
                                                                                onClick={() => {
                                                                                    setEditingEmailId(e.id);
                                                                                    setEditingEmailValue(e.email);
                                                                                }}
                                                                            ><i className="fa fa-pencil-square-o"></i></button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-outline-danger"
                                                                                title="Delete"
                                                                                onClick={() => {
                                                                                    Swal.fire({
                                                                                        position: 'center',
                                                                                        text: 'Do you want to delete this email?',
                                                                                        showConfirmButton: true,
                                                                                        confirmButtonText: 'Yes',
                                                                                        showCancelButton: true,
                                                                                        cancelButtonText: 'No',
                                                                                        width: '400px',
                                                                                    }).then((result) => {
                                                                                        if (result.value === true) {
                                                                                            axios({
                                                                                                method: 'POST',
                                                                                                url: `${baseUrl}/mobile-group/email/${e.id}/delete`,
                                                                                                headers: { Authorization: token }
                                                                                            }).then(() => {
                                                                                                setAllEmails(allEmails.filter(m => m.id !== e.id));
                                                                                                if (selectedAssignEmail?.id === e.id) setSelectedAssignEmail(null);
                                                                                                toast.success('Email deleted', { position: 'bottom-center' });
                                                                                            }).catch((error) => {
                                                                                                console.log(error);
                                                                                                toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                                                                            });
                                                                                        }
                                                                                    });
                                                                                }}
                                                                            ><i className="icon-trash"></i></button>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </li>
                                                        ))
                                                    }
                                                    {allEmails.filter(e => e.email.toLowerCase().includes(emailSearch.trim().toLowerCase())).length === 0 && (
                                                        <li className="list-group-item">No results</li>
                                                    )}
                                                </ul>
                                            </>
                                        )}
                                    </div>

                                    {/* Right: available groups */}
                                    <div className="col-7">
                                        <p className="advance-view-title mb-2">
                                            {assignMode === 'numbers'
                                                ? (selectedAssignNumber ? `Groups for ${selectedAssignNumber.number}` : 'Select a number to see groups')
                                                : (selectedAssignEmail ? `Groups for ${selectedAssignEmail.email}` : 'Select an email to see groups')
                                            }
                                        </p>
                                        {(assignMode === 'numbers' ? selectedAssignNumber : selectedAssignEmail) ? (
                                            <ul className="list-group">
                                                {numberGroupsList.length > 0 ? (
                                                    numberGroupsList.map((group, i) => (
                                                        <li key={i} className="list-group-item d-flex justify-content-between align-items-center">
                                                            {group.name}
                                                            {group.assigned ? (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    title="Remove assignment"
                                                                    onClick={() => {
                                                                        axios({
                                                                            method: 'POST',
                                                                            url: `${baseUrl}/mobile-group/${assignMode === 'emails' ? 'assign-to-email' : 'assign-to-number'}`,
                                                                            headers: { Authorization: token },
                                                                            data: assignMode === 'emails'
                                                                                ? { emailId: selectedAssignEmail.id, groupId: group.id }
                                                                                : { number: selectedAssignNumber.id, groupId: group.id }
                                                                        }).then(() => {
                                                                            setNumberGroupsList(numberGroupsList.map(g =>
                                                                                g.id === group.id ? { ...g, assigned: false } : g
                                                                            ));
                                                                            toast.success(`Removed from ${group.name}`, { position: 'bottom-center' });
                                                                            if (selectedSmsGroup.id === group.id) {
                                                                                assignMode === 'emails' ? getEmailsByGroup() : getNumbersByGroup();
                                                                            }
                                                                        }).catch((error) => {
                                                                            console.log(error);
                                                                            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                                                        });
                                                                    }}
                                                                >
                                                                    <i className="icon-trash"></i>
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-primary"
                                                                    title="Assign to this group"
                                                                    onClick={() => {
                                                                        axios({
                                                                            method: 'POST',
                                                                            url: `${baseUrl}/mobile-group/${assignMode === 'emails' ? 'assign-to-email' : 'assign-to-number'}`,
                                                                            headers: { Authorization: token },
                                                                            data: assignMode === 'emails'
                                                                                ? { emailId: selectedAssignEmail.id, groupId: group.id }
                                                                                : { number: selectedAssignNumber.id, groupId: group.id }
                                                                        }).then(() => {
                                                                            setNumberGroupsList(numberGroupsList.map(g =>
                                                                                g.id === group.id ? { ...g, assigned: true } : g
                                                                            ));
                                                                            toast.success(`Assigned to ${group.name}`, { position: 'bottom-center' });
                                                                            if (selectedSmsGroup.id === group.id) {
                                                                                assignMode === 'emails' ? getEmailsByGroup() : getNumbersByGroup();
                                                                            }
                                                                        }).catch((error) => {
                                                                            console.log(error);
                                                                            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                                                        });
                                                                    }}
                                                                >
                                                                    <i className="fa fa-plus"></i>
                                                                </button>
                                                            )}
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li className="list-group-item">No groups available</li>
                                                )}
                                            </ul>
                                        ) : (
                                            <p className="text-muted">
                                                {assignMode === 'numbers'
                                                    ? 'Search and select a mobile number on the left.'
                                                    : 'Search and select an email on the left.'}
                                            </p>
                                        )}
                                    </div>

                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowAssignGroupsModal(false)}>Close</button>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {/* ── Add Emails Modal ── */}
            {showAddEmailsModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">Add Emails</h5>
                                <button type="button" className="close" onClick={() => setShowAddEmailsModal(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                {emailInputs.map((val, i) => (
                                    <div key={i} className="input-group mb-2">
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Enter email address"
                                            value={val}
                                            onChange={(e) => {
                                                const updated = [...emailInputs];
                                                updated[i] = e.target.value;
                                                setEmailInputs(updated);
                                            }}
                                        />
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-outline-danger"
                                                type="button"
                                                disabled={emailInputs.length === 1}
                                                onClick={() => {
                                                    setEmailInputs(emailInputs.filter((_, idx) => idx !== i));
                                                }}
                                            >
                                                <i className="icon-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary mt-1"
                                    onClick={() => setEmailInputs([...emailInputs, ''])}
                                >
                                    <i className="fa fa-plus mr-1"></i>Add Another
                                </button>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowAddEmailsModal(false)}>Cancel</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        const valid = emailInputs.filter(e => e.trim() !== '');
                                        if (valid.length === 0) {
                                            toast.error('Enter at least one email', { position: 'bottom-center' });
                                            return;
                                        }
                                        axios({
                                            method: 'POST',
                                            url: `${baseUrl}/mobile-group/add-emails`,
                                            headers: { Authorization: token },
                                            data: {
                                                branchId: selectedBranchId,
                                                emails: valid.map(e => e.trim())
                                            }
                                        }).then(() => {
                                            setShowAddEmailsModal(false);
                                            toast.success('Emails added', { position: 'bottom-center' });
                                        }).catch((error) => {
                                            console.log(error);
                                            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                        });
                                    }}
                                >Add</button>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {/* ── Add Mobile Numbers Modal ── */}
            {showAddNumbersModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title">Add Mobile Numbers</h5>
                                <button type="button" className="close" onClick={() => setShowAddNumbersModal(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                {phoneInputs.map((val, i) => (
                                    <div key={i} className="input-group mb-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter mobile number"
                                            value={val}
                                            onChange={(e) => {
                                                const updated = [...phoneInputs];
                                                updated[i] = e.target.value;
                                                setPhoneInputs(updated);
                                            }}
                                        />
                                        <div className="input-group-append">
                                            <button
                                                className="btn btn-outline-danger"
                                                type="button"
                                                disabled={phoneInputs.length === 1}
                                                onClick={() => {
                                                    setPhoneInputs(phoneInputs.filter((_, idx) => idx !== i));
                                                }}
                                            >
                                                <i className="icon-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary mt-1"
                                    onClick={() => setPhoneInputs([...phoneInputs, ''])}
                                >
                                    <i className="fa fa-plus mr-1"></i>Add Another
                                </button>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowAddNumbersModal(false)}>Cancel</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        const valid = phoneInputs.filter(n => n.trim() !== '');
                                        if (valid.length === 0) {
                                            toast.error('Enter at least one number', { position: 'bottom-center' });
                                            return;
                                        }
                                        axios({
                                            method: 'POST',
                                            url: `${baseUrl}/mobile-group/add-numbers`,
                                            headers: { Authorization: token },
                                            data: {
                                                branchId: selectedBranchId,
                                                mobileNumbers: valid.map(n => n.trim())
                                            }
                                        }).then((res) => {
                                            if (Object.keys(selectedSmsGroup).length > 0) {
                                                getNumbersByGroup();
                                            }
                                            setShowAddNumbersModal(false);
                                            toast.success('Numbers added', { position: 'bottom-center' });
                                        }).catch((error) => {
                                            console.log(error);
                                            toast.error(error.response?.data?.message || 'Something went wrong', { position: 'bottom-center' });
                                        });
                                    }}
                                >Add</button>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default SmsGroup;
